module.exports = __webpack_public_path__ + "static/media/logo-footer.1e660415.svg";